import type { ExternalTableSchema } from '@packages/table-builder';

/** List data parity: useGetDrsRegistrationDashboard (GET via dataSource.endpoint). */
export const drsRegistrationDashboardBaseSchema: ExternalTableSchema = {
  metadata: {
    title: 'DRS Registration Dashboard',
    entity: 'DrsRegistrationDashboard',
    description: 'DRS registration dashboard grouped by date.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/transfer-allocate/transfer-allocate-dashboard-for-drs',
    method: 'GET',
    rowIdField: 'id',
    requestParams: {
      Filter: '',
      CompanyId: 'filters.companyId',
      ContainerStatusIds: 'filters.containerStatusIds',
    },
    filters: [
      {
        name: 'companyId',
        placeholder: 'Company',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/transfer-agent-company/transfer-agent-managed-companies',
          labelField: 'companyName',
          valueField: 'id',
        },
      },
      {
        name: 'containerStatusIds',
        placeholder: 'Container Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/transfer-allocate/container-statuses',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'creationTime',
      header: 'Date',
      type: 'date',
      sortable: true,
      width: 140,
      align: 'center',
    },
    {
      field: 'companyName',
      header: 'Company',
      sortable: false,
      width: 120,
    },
    {
      field: 'ticker',
      header: 'Ticker',
      sortable: true,
      width: 150,
      align: 'center',
    },
    {
      field: 'containerStatus',
      header: 'Container Status',
      type: 'badge',
      sortable: true,
      width: 200,
      align: 'center',
      badge: {
        statusMap: {
          Executed: 'success',
          Placed: 'success',
          Allocated: 'info',
          Pending: 'info',
          Cancelled: 'error',
          'Partially Filled': 'pink-tag',
          Received: 'success',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'dwacNumber',
      header: 'Dwac Number',
      sortable: true,
      width: 200,
      align: 'center',
    },
    {
      field: 'totalTransferShare',
      header: 'Total Transfer Shares',
      sortable: true,
      width: 150,
      align: 'center',
    },
  ],

  actions: {
    row: [{ id: 'VIEW_DETAILS_DRS_REGISTRATION_DASHBOARD', label: 'View Details' }],
  },

  features: {
    search: { enabled: false },
    // Legacy showPagination:false — full list client-side; groupBy needs all rows, not one infiniteScroll page.
    pagination: { mode: 'none' },
    virtualScroll: { enabled: false },
    groupBy: {
      fields: ['creationTime'],
      expandMode: 'expanded',
      hideGroupedColumn: false,
      groupHeader: { showCount: true },
    },
  },
};
